<template>
  <div
    v-if="!isProduction"
    class="environment-badge"
    :title="`Connected to Firebase project ${projectId}`"
    aria-hidden="true"
  >
    {{ label }} · {{ projectId }}
  </div>
</template>

<script>
  // Shows a small, always-visible badge on every non-production build so a dev
  // or staging site can never be mistaken for the live app. Renders nothing in production.
  import { APP_ENV, FIREBASE_PROJECT_ID, IS_PRODUCTION } from '@/helpers/firebaseEnv'

  export default {
    name: 'EnvironmentBadge',
    data() {
      return {
        isProduction: IS_PRODUCTION,
        projectId: FIREBASE_PROJECT_ID,
        label: APP_ENV === 'staging' ? 'DEV SITE' : 'LOCAL DEV',
      }
    },
  }
</script>

<style scoped>
  .environment-badge {
    position: fixed;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10000;
    padding: 4px 12px;
    border-radius: 999px;
    background: #c62828;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    pointer-events: none;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  }

  @media print {
    .environment-badge {
      display: none;
    }
  }
</style>
